import { __assign } from "tslib";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var Cookie = React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return React.createElement(StyledIconBase, __assign({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), React.createElement("path", {
    d: "M21.598 11.064a1.006 1.006 0 00-.854-.172A2.938 2.938 0 0120 11c-1.654 0-3-1.346-3.003-2.937.005-.034.016-.136.017-.17a.998.998 0 00-1.254-1.006A2.963 2.963 0 0115 7c-1.654 0-3-1.346-3-3 0-.217.031-.444.099-.716a1 1 0 00-1.067-1.236A9.956 9.956 0 002 12c0 5.514 4.486 10 10 10s10-4.486 10-10c0-.049-.003-.097-.007-.16a1.004 1.004 0 00-.395-.776zM12 20c-4.411 0-8-3.589-8-8a7.962 7.962 0 016.006-7.75A5.006 5.006 0 0015 9l.101-.001a5.007 5.007 0 004.837 4C19.444 16.941 16.073 20 12 20z",
    key: "k0"
  }), React.createElement("circle", {
    cx: 12.5,
    cy: 11.5,
    r: 1.5,
    key: "k1"
  }), React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 1.5,
    key: "k2"
  }), React.createElement("circle", {
    cx: 7.5,
    cy: 12.5,
    r: 1.5,
    key: "k3"
  }), React.createElement("circle", {
    cx: 15.5,
    cy: 15.5,
    r: 1.5,
    key: "k4"
  }), React.createElement("circle", {
    cx: 10.5,
    cy: 16.5,
    r: 1.5,
    key: "k5"
  }));
});
Cookie.displayName = 'Cookie';
export var CookieDimensions = {
  height: 24,
  width: 24
};